define('fukit/view/block/ellipsis.column.view',['require','exports','module','uikit/uikit','../../behavior/resolve.options.behavior','../../behavior/show.detail.on.event.behavior','../../helpers/roles.helper'],function(require, exports, module) {
  //prettier-ignore
  var UIKit = require('uikit/uikit'),
      ResolveOptionsBehavior = require('../../behavior/resolve.options.behavior'),
      ShowDetailOnEventBehavior = require('../../behavior/show.detail.on.event.behavior'),
      RolesHelper = require('../../helpers/roles.helper');

  var EllipsisColumnView = UIKit.TableEllipsis.extend({
    behaviors: {
      ResolveOptionsBehavior: {
        behaviorClass: ResolveOptionsBehavior,
      },
    },

    initialize: function() {
      UIKit.TableEllipsis.prototype.initialize.apply(this, arguments);

      //prettier-ignore
      var visibleOnlyWhen = this.getOption('visibleOnlyWhen'),
          option;

      if (visibleOnlyWhen) {
        option = RolesHelper.getMatchedOption(visibleOnlyWhen);
        this.view.visible = RolesHelper.evaluateRolesOptions(option.roles);
      }

      this.on('resolve:options', function() {
        this.collection = new Backbone.Collection(this.getOption('components'));
      });
    },
  });
  module.exports = EllipsisColumnView;
});

